import React from 'react';
import { Link } from 'react-router-dom';
import LoginComponent from './LoginComponent'

import './LoginComponent.sass';

function LoginComponentWrapper() {
    return (
        <>
            <div id='login-wrapper'>
                <LoginComponent />
            </div>
        </>
    )
}

export default LoginComponentWrapper;